import React, { Component } from 'react'
import * as sText from 'components/Text/Text.scss'
import * as sMarg from 'styles/modules/margins.scss'
import { Container } from 'components/Layout'
import cn from 'classnames'
import { PhoneSystemHuntGroupEditForm } from '../PhoneSystemHuntGroupEditForm'
import { IHuntGroupFormData } from '../PhoneSystemHuntGroupEditForm/PhoneSystemHuntGroupEditForm.container'

export interface IPhoneSystemHuntGroupEditFormModalProps extends IHuntGroupFormData {
  modalCancel: () => undefined
  modalConfirm: () => undefined
}

export class PhoneSystemHuntGroupEditFormModal extends Component<
  IPhoneSystemHuntGroupEditFormModalProps
> {
  render() {
    const {
      modalConfirm,
      huntGroupId,
      extensionIds,
      name,
      number,
      phoneSystemId,
      huntSequence,
    } = this.props

    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center, sMarg.mb30)}>
            {!!huntGroupId ? 'Edit' : 'Add'} Hunt Group:
          </div>

          <PhoneSystemHuntGroupEditForm
            onAfterSubmit={modalConfirm}
            initialValues={{
              phoneSystemId,
              huntGroupId,
              extensionIds,
              name,
              number,
              huntSequence,
            }}
          />
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemHuntGroupEditFormModal/PhoneSystemHuntGroupEditFormModal.tsx